const React = require('react');
const SentryWrapper = require('./src/components/SentryWrapper');

exports.onClientEntry = () => {
  // --- Cookie Banner ---
  var SCRIPT_URL =
    window.location.host === 'www.datacamp.com'
      ? 'https://cookie-cdn.cookiepro.com/consent/3a4d67ad-f79f-4146-9539-f78ec64a9de4.js'
      : 'https://cookiepro.blob.core.windows.net/consent/3a4d67ad-f79f-4146-9539-f78ec64a9de4-test.js';
  var cookieBannerScript = document.createElement('script');
  cookieBannerScript.src = SCRIPT_URL;
  cookieBannerScript.type = 'text/javascript';
  cookieBannerScript.charset = 'UTF-8';
  document.body.appendChild(cookieBannerScript);

  function OptanonWrapper() {}
  // --- Cookie Banner ---

  // --- Google Tag Manager ---
  let dataLayerContent = {
    user_id: 'anonymous',
    type: 'non-registered',
  };

  if (typeof window['dataLayer'] === 'undefined') {
    window['dataLayer'] = [dataLayerContent];
  } else {
    window['dataLayer'].push(dataLayerContent);
  }

  const waitForCookieBanner = callback => {
    if (typeof Optanon === 'undefined') {
      setTimeout(() => {
        waitForCookieBanner(callback);
      }, 100);
    } else {
      callback();
    }
  };

  waitForCookieBanner(() => {
    (function(w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-TGGWB2P');
  });
  // --- Google Tag Manager ---

  // --- Snowplow ---
  var snowplowOptions = {
    platform: 'web',
    appId: 'resource-center',
    post: true,
    discoverRootDomain: true,
    contexts: {
      webPage: true,
      performanceTiming: true,
    },
  };

  if (process.env.SNOWPLOW_ENDPOINT !== 'com-datacamp.mini.snplow.net') {
    snowplowOptions.forceSecureTracker = true;
    snowplowOptions.postPath = '/spevent';
  }

  window.snowplow(
    'newTracker',
    'co',
    process.env.SNOWPLOW_ENDPOINT,
    snowplowOptions
  );
  window.snowplow('enableActivityTracking', 10, 10); // Ping every 10 seconds after 10 seconds
  window.snowplow('setUserIdFromCookie', 'dc_aid');

  var userContext = {
    schema: 'iglu:com.datacamp/user/jsonschema/1-0-0',
    data: {},
  };

  window.snowplow('trackPageView', null, [userContext]);
  window.snowplow('enableLinkClickTracking', null, null, false, [userContext]);

  window.snowplow('enableFormTracking');
  // --- Snowplow ---
};

exports.wrapRootElement = SentryWrapper;
